import React from 'react';
import PropTypes from 'prop-types';
import AssignmentPreviewModal from '../../AssignmentPreviewModal';

const AssignMenuPreviewModal = ({ modalData, setModalData }) => {
  return (
    <>
      {modalData && (
        <AssignmentPreviewModal
          isOpen={modalData}
          onClose={() => setModalData(false)}
        />
      )}
    </>
  );
};

AssignMenuPreviewModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func
};

export default AssignMenuPreviewModal;
